import { useState } from 'react';
import { useApi } from '../../../utils/hooks';
import { IPasswordValidatorResult } from '../../../utils/constants/interfaces';

const useChangePasswordForm = () => {
  const api = useApi();
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [changeResult, setChangeResult] = useState<boolean | null>(null);
  const [validatorResult, setValidatorResult] = useState<IPasswordValidatorResult>({
    currentPassword: '',
    newPassword: '',
    isValid: false
  });

  const handleSubmit = (e: React.SyntheticEvent): void => {
    setSubmitted(true);
    e.preventDefault();
    void changePassword();
  };

  const changePassword = async (): Promise<void> => {
    const apiResponseChange = await api.post<boolean>(
      '/users/me/change-password',
      JSON.stringify(validatorResult)
    );

    if (!apiResponseChange?.response || apiResponseChange.status.statusCode !== 200) {
      setChangeResult(false);
    } else {
      setChangeResult(apiResponseChange.response ?? false);
    }
  };

  const passwordCallback = (value: IPasswordValidatorResult): void => {
    setValidatorResult(value);
  };

  return {
    submitted,
    validatorResult,
    changeResult,
    handleSubmit,
    passwordCallback
  };
};

export default useChangePasswordForm;
